export interface ISPpMakeFolderKey {
  key: string;
  default?: boolean;
  hidden?: boolean;
  localization: Record<string, string>;
}
export const spMakeFolders: ISPpMakeFolderKey[] = [
  {
    key: 'account',
    default: true,
    localization: {
      en: 'Account management',
      de: 'Account Management',
    },
  },
  {
    key: 'creation',
    localization: {
      en: 'Creative',
      de: 'Kreation',
    },
  },
  {
    key: 'still',
    localization: {
      en: 'Still',
      de: 'Still',
    },
  },
  {
    key: 'digital',
    localization: {
      en: 'Digital',
      de: 'Digital',
    },
  },
  {
    key: 'phygital',
    localization: {
      en: 'Phygital',
      de: 'Phygital',
    },
  },
  {
    key: 'neverest',
    localization: {
      en: 'Neverest',
      de: 'Neverest',
    },
  },
  {
    key: 'production',
    localization: {
      en: 'Production',
      de: 'Produktion',
    },
  },
  {
    key: 'final_master',
    default: true,
    hidden: true,
    localization: {
      en: 'Final Master',
      de: 'Finales Master',
    },
  },
];
